import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { dModelTransferNumber, portInEligibilityRequest, portInMsisdnReq, RequestsBulkPortin, MultiLineBulkPortinHeaders } from '../../../common/models/data.model';
import { UtilsService } from 'src/app/services/utils.service';
import { LoaderService } from 'src/app/services/loader.service';
import * as _ from 'lodash';
import { SuccessComponent } from '../success/success.component';
import {
  COMMON_CONSTANTS,
  MANAGE_LINE_CONST,
  TRANSFER_NUMBER_CONSTANTS,
  SIM_CHANGE_CONST,
  VALUE,
  ENTITLEMENT_ACTIVITYNAMES,
  ANALYTICS
} from '../../../common/core/common.constants';
import { NgbModal, NgbModalOptions, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { isNullOrUndefined } from 'src/app/services/utils';
import { DateFormatTransferService } from 'src/app/services/date-format-transfer.service';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { PDLService } from 'src/app/services/pdl-service.service';

@Component({
  selector: "app-transfer-number",
  templateUrl: "./transfer-number.component.html",
  styleUrls: ["./transfer-number.component.scss"],
  providers: [
    { provide: NgbDateParserFormatter, useClass: DateFormatTransferService },
  ],
})
export class TransferNumberComponent implements OnInit {
  selectedLines: any = "";
  individually = false;
  allLineOpenModal = true;
  totalNumberDetails: any = [0];
  IndividualLine: any;
  ban: any;
  dealerCode: any;
  authoringContentData: any;
  panelOpenState = false;
  successModalRef: any;
  nonActiveLines = [];
  maximumTransferDate: any;
  minimumTransferDate: any;
  isValidNumberToTfr = true;
  isValidAcNumber = true;
  regex19 = SIM_CHANGE_CONST.REGEX19;
  regex20 = SIM_CHANGE_CONST.REGEX20;
  regex21 = SIM_CHANGE_CONST.REGEX21;
  isDisabled = true;
  isDisabledAcNo = true;
  isDisabledDate = true;
  isEndUser: boolean;
  portInDate: any;
  errorOrSuccessMessage;
  tranNumber: any;
  accountNumber: any;
  accountPassword: any;
  eligibleTransferDate: any;
  isLineDetailsWindow: boolean;
  isSingleFlow: boolean = false;
  showCarrier: boolean = false;
  allCarrierNumber: any;
  requestPortin: any;
  isLineValidated = false;
  validatedLines: any = [];
  enableSubmitBtn: boolean = false;
  portInPSTDate: any;
  isSubmitReadOnly: any;
  userType: any;
  isMaxReach: boolean = false;
  header: any;
  msg: any;
  ngbModalOptions: NgbModalOptions;
  nameTag: string;

  manageLineService: ManageLineService;
  utilsSvc: UtilsService;
  _cacheSvc: HttpCacheService;
  _loaderSvc: LoaderService;
  modalService: NgbModal;
  _helperUtilSvc: HelperUtilityService;
  pdlService: PDLService;
  eligiblilityCalled: boolean;
  changeDetector:ChangeDetectorRef;

  constructor(
    private injector: Injector
  ) {
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.pdlService = this.injector.get<PDLService>(PDLService);
    this.changeDetector = this.injector.get<ChangeDetectorRef>(ChangeDetectorRef);

    this.isLineDetailsWindow = false;
  }

  ngOnInit() {
    this.portInDate = "";
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().transferNumberAuthoring;
    this.individually = Boolean(this.selectedLines.length === 1);
    this.isSingleFlow = this.individually;
    this.isEndUser = this._helperUtilSvc.isEndUser();
    this.isSubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.TRANSFER_NUMBER);
    this.selectedLines[0].expendFlagValue = true;
    this.getPSTDate();
    this.portInDate = this.minimumTransferDate;
    this.resetCarrierNumber();
    for (let line of this.selectedLines) {
      line.portDate = this.portInDate;
    }
    if (this.individually) {
      this.resetFields();
    }

    this.nameTag = this.authoringContentData.transferNumber;
    if (!this.isSingleFlow) {
      this.nameTag = ANALYTICS.MULTILINE_NUMBER_TRANSFER;
    }
    this.generateModalViewTag();
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  getPSTDate() {
    const maxMinDates = this.utilsSvc.getMaxMinDates();
    if (maxMinDates?.length) {
      this.minimumTransferDate = maxMinDates[0];
      this.maximumTransferDate = maxMinDates[1];
    }
  }

  showCarrierNumber(event: any) {
    if (event.checked === true) {
      this.showCarrier = true;
    } else {
      this.showCarrier = false;
      this.resetCarrierNumber();
    }
  }

  resetCarrierNumber() {
    this.allCarrierNumber = "";
    for (let line of this.selectedLines) {
      line.carrierNumber = "";
    }
  }

  resetFields() {
    for (let i = 0; i < this.selectedLines.length; i++) {
      if (
        !isNullOrUndefined(
          this.selectedLines[i][TRANSFER_NUMBER_CONSTANTS.TRAN_NUMBER]
        )
      ) {
        this.selectedLines[i] = _.omit(
          this.selectedLines[i],
          TRANSFER_NUMBER_CONSTANTS.TRAN_NUMBER
        );
        this.selectedLines[i] = _.omit(
          this.selectedLines[i],
          TRANSFER_NUMBER_CONSTANTS.IS_VALID_NUMBER_TO_TFR
        );
        this.selectedLines[i] = _.omit(
          this.selectedLines[i],
          TRANSFER_NUMBER_CONSTANTS.ERROR_ON_SUCCESS_MSG
        );
      }
      if (
        this.selectedLines[i][TRANSFER_NUMBER_CONSTANTS.CARRIER_NUMBER] != ""
      ) {
        this.selectedLines[i][TRANSFER_NUMBER_CONSTANTS.CARRIER_NUMBER] = "";
      }
      if (
        !isNullOrUndefined(
          this.selectedLines[i][TRANSFER_NUMBER_CONSTANTS.ACCOUNT_PIN_PASS]
        )
      ) {
        this.selectedLines[i] = _.omit(
          this.selectedLines[i],
          TRANSFER_NUMBER_CONSTANTS.ACCOUNT_PIN_PASS
        );
      }
      if (
        !isNullOrUndefined(
          this.selectedLines[i][TRANSFER_NUMBER_CONSTANTS.PORT_TIME]
        )
      ) {
        this.selectedLines[i] = _.omit(
          this.selectedLines[i],
          TRANSFER_NUMBER_CONSTANTS.PORT_TIME
        );
      }
      if (!isNullOrUndefined(this.selectedLines[i]['isCarrierNumberAll'])) {
        this.selectedLines[i] = _.omit(this.selectedLines[i], 'isCarrierNumberAll');
        this.selectedLines[i]['isCarrierNumberValid'] = "";
      }
    }
  }

  populateCarrierNumber(carrierNumber: any) {
    if (!isNullOrUndefined(this.selectedLines)) {
      for (let i = 0; i <= this.selectedLines.length; i++) {
        if (!isNullOrUndefined(this.selectedLines[i] && this.selectedLines[i].carrierNumber)) {
          this.selectedLines[i].carrierNumber = carrierNumber;
          if (this.selectedLines[i].carrierNumber.length >= VALUE.ONE && this.selectedLines[i].carrierNumber.length <= VALUE.THIRTY) {
            this.selectedLines[i].isCarrierNumberValid = true;
            this.selectedLines[i].isCarrierNumberAll = true;
          }
        }
      }
    }

  }
  removeTransferNumber(line) {
    if (!isNullOrUndefined(line)) {
      const index = this.selectedLines.indexOf(line);
      this.selectedLines.splice(index, 1);
      this.manageLineService.changeCurrentSelection(line);
      this.enableSubmitButton();
    }
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.REMOVE_NUMBER,
      assetType: ANALYTICS.LINK,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }

  getNumberEligibilty(tranNumber: any, accountNumber?: any) {
    if (!isNullOrUndefined(tranNumber)) {
      if (this.regex21.test(tranNumber)) {
        this.isValidNumberToTfr = true;
        this.isDisabled = false;
      } else {
        this.isValidNumberToTfr = false;
        this.isDisabled = true;
      }
    }
    if (!isNullOrUndefined(accountNumber)) {
      this.checkEligibility(tranNumber, accountNumber);
    } else {
      this.checkEligibility(tranNumber);
    }
  }
  checkEligibility(tranNumber, accountNumber?: any) {
    if (!isNullOrUndefined(tranNumber) && tranNumber.length > 9) {
      this._loaderSvc.start();
      const objTransferNumber = new portInEligibilityRequest();
      objTransferNumber.billingAccountNumber = this._cacheSvc.getFromSessionStorage(
        COMMON_CONSTANTS.BAN_NUMBER_KEY
      );
      objTransferNumber.type = TRANSFER_NUMBER_CONSTANTS.ELIGIBILITY_REQ_TYPE;
      const msisdnReq = new portInMsisdnReq();
      msisdnReq.portInDateTime = this.calenderDateToUTC(this.portInDate);
      msisdnReq.oldMsisdn = this.selectedLines[
        COMMON_CONSTANTS.DIGITS.ZERO
      ].msisdn;
      msisdnReq.portInNumber = tranNumber;
      if (!isNullOrUndefined(accountNumber)) {
        msisdnReq.ospAccountNumber = accountNumber;
      }
      objTransferNumber.msisdns[COMMON_CONSTANTS.DIGITS.ZERO] = msisdnReq;
      objTransferNumber.billingAccountNumber = this._cacheSvc.getFromSessionStorage(
        COMMON_CONSTANTS.BAN_NUMBER_KEY
      );
      this.manageLineService
        .transferNumberSingleLineEligibilty(objTransferNumber)
        .subscribe(
          (data) => {
            this.eligiblilityCalled = true;
            this.checkEligibilityResponse(data);
          },
          (error) => {
            this.errorOrSuccessMessage = false;
            this._loaderSvc.stop();
          }
        );
    } else {
      this.errorOrSuccessMessage = false;
    }
  }
  checkEligibilityResponse(data) {
    if (!isNullOrUndefined(data) && !isNullOrUndefined(data.msisdns) && !isNullOrUndefined(data.msisdns[COMMON_CONSTANTS.DIGITS.ZERO].status)
      && data.msisdns[COMMON_CONSTANTS.DIGITS.ZERO].status === MANAGE_LINE_CONST.SUCCESS
      && !isNullOrUndefined(data.msisdns[COMMON_CONSTANTS.DIGITS.ZERO].portInAvailableDate)) {
      this.errorOrSuccessMessage = true;
      this.mapEligibleTransferDate(data);
      this._loaderSvc.stop();
    } else {
      this.errorOrSuccessMessage = false;
      this._loaderSvc.stop();
    }
  }
  mapEligibleTransferDate(data) {
    const dateTimeArray = data.msisdns[COMMON_CONSTANTS.DIGITS.ZERO].portInAvailableDate.split(COMMON_CONSTANTS.CHAR_T);
    if (!isNullOrUndefined(dateTimeArray) && !isNullOrUndefined(dateTimeArray.length) && dateTimeArray.length !== COMMON_CONSTANTS.DIGITS.ZERO && !isNullOrUndefined(dateTimeArray[0])) {
      const dateArray = dateTimeArray[COMMON_CONSTANTS.DIGITS.ZERO].split(COMMON_CONSTANTS.SYMBOLS.DASH);
      if (!isNullOrUndefined(dateArray) && !isNullOrUndefined(dateArray.length) && dateArray.length !== COMMON_CONSTANTS.DIGITS.ZERO
        && !isNullOrUndefined(dateArray[COMMON_CONSTANTS.DIGITS.TWO]) && !isNullOrUndefined(dateArray[COMMON_CONSTANTS.DIGITS.ONE]) && !isNullOrUndefined(dateArray[COMMON_CONSTANTS.DIGITS.ZERO])) {
        this.eligibleTransferDate = {
          year: Number(dateArray[COMMON_CONSTANTS.DIGITS.ZERO]),
          month: Number(dateArray[COMMON_CONSTANTS.DIGITS.ONE]),
          day: Number(dateArray[COMMON_CONSTANTS.DIGITS.TWO]),
        };
        this.portInDate = this.eligibleTransferDate;
      }
    }
  }
  calenderDateToUTC(objDate) {
    const monthParsed = objDate.month < 10 ? "0" + objDate.month : objDate.month;
    const dayParsed = objDate.day < 10 ? "0" + objDate.day : objDate.day;
    return objDate.year + "-" + monthParsed + "-" + dayParsed + COMMON_CONSTANTS.DEFAULT_TIMEZONE;
  }

  getErrorMessageAccountNumber(accountNumber: any, tranferDate: any) {
    if (!isNullOrUndefined(accountNumber)) {
      if (accountNumber.length >= COMMON_CONSTANTS.COUNT_ONE) {
        this.isValidAcNumber = true;
        this.isDisabledAcNo = false;
      } else {
        this.isValidAcNumber = false;
        this.isDisabledAcNo = true;
      }
    }
    if (isNullOrUndefined(tranferDate)) {
      this.isDisabledDate = true;
    } else {
      this.isDisabledDate = false;
    }
  }

  submitSingleTransferNumberRequest() {
    const objTransferNumber = new dModelTransferNumber();
    objTransferNumber.msisdn = this.selectedLines[
      COMMON_CONSTANTS.DIGITS.ZERO
    ].msisdn;
    objTransferNumber.newMsisdn = this.tranNumber;
    objTransferNumber.portInDateTime = this.calenderDateToUTC(
      this.portInDate
    );
    objTransferNumber.billingAccountNumber = this._cacheSvc.getFromSessionStorage(
      COMMON_CONSTANTS.BAN_NUMBER_KEY
    );
    objTransferNumber.logonId = _.get(
      JSON.parse(
        this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)
      ),
      "logonId",
      ""
    );
    objTransferNumber.email = _.get(
      JSON.parse(
        this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)
      ),
      "logonId",
      ""
    );
    objTransferNumber.reasonCode = TRANSFER_NUMBER_CONSTANTS.REASON_CODE_PR;
    objTransferNumber.ospAccount = this.accountNumber;
    objTransferNumber.ospAccountPassword = this.accountPassword;
    this.manageLineService
      .transferNunmberSingleLine(objTransferNumber)
      .subscribe(
        (data) => {
          if (
            !isNullOrUndefined(data) &&
            !isNullOrUndefined(data.status) &&
            data.status === MANAGE_LINE_CONST.SUCCESS
          ) {
            this._loaderSvc.stop();
            this.manageLineService.close();
            this.generateSuccessfullySubmittedTag();
            this.openSuccessConfirmPopup(data);
          } else {
            this.userType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) || COMMON_CONSTANTS.IAM_KEY;
            if (!isNullOrUndefined(data) && !isNullOrUndefined(data.error) && data.error[0].code == COMMON_CONSTANTS.FRAUD_ERROR_CODE && this.userType === COMMON_CONSTANTS.IAM_KEY
            ) {
              this.header = this.authoringContentData.fraudHeading;
              this.msg = data.error[0].userMessage;
              this.isMaxReach = true;
              this.generateMaxAttemptsTag();
            }
          }
        },
        (error) => {
          this.utilsSvc.errorHandling(error);
          this._loaderSvc.stop();
        }
      );
  }

  openSuccessConfirmPopup(data) {
    const approvalFlags = JSON.parse(
      this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.APPROVALFLAGS) || '[]'
    )

    let isApprovalRequired = approvalFlags?.find((item) => { return item?.FlagName == COMMON_CONSTANTS.IS_PORT_IN_APPROVAL });
    isApprovalRequired = isApprovalRequired?.FlagValue == COMMON_CONSTANTS.DIGITS.ONE ? true : false;

    const successModalRef = this.modalService.open(
      SuccessComponent,
      this.ngbModalOptions
    );
    successModalRef.componentInstance.tagEnabledByCaller = true;
    successModalRef.componentInstance.nameTag = this.nameTag;
    successModalRef.componentInstance.isLineDetailsWindow = this.isLineDetailsWindow;
    successModalRef.componentInstance.isPortIn = true;
    if (this.isEndUser && isApprovalRequired) {
      //confirmation popup here
      successModalRef.componentInstance.header = this.authoringContentData.portInConfirmationHeader;
      successModalRef.componentInstance.isConfirmationPopup = true;
      successModalRef.componentInstance.processText = this.authoringContentData.portInProcessText;
      successModalRef.componentInstance.orderStatus = data;
      successModalRef.componentInstance.modalBodyContent = this.authoringContentData.portInApprovalText
    } else {
      successModalRef.componentInstance.header = this.authoringContentData.singleLineSuccessModalTitle;
      successModalRef.componentInstance.modalBodyContent = this.authoringContentData.confirmationMsgTxt.replace(
        "{{emailID}}",
        _.get(
          JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)) || {},
          "logonId",
          ""
        )
      );

      successModalRef.componentInstance.portInSuccessTransaction = this.authoringContentData.singletransactionNumberTxt.replace(
        "{{transID}}",
        data.accountTransactionReferenceNumber
      );
    }

  }

  submitBulkTransferNumberRequest() {
    this.requestPortin = this.updatedPortinBulkRequestHeader(
      this.selectedLines
    );
    this.requestPortin.targetServiceName = SIM_CHANGE_CONST.PORTIN_TXT;
    this.requestPortin.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      container: '#am-container-custom',
    };
    this.manageLineService
      .bulkTransferNumberProcessor(this.requestPortin)
      .subscribe(
        (data) => {
          if (
            !isNullOrUndefined(data) &&
            !isNullOrUndefined(data.status) &&
            data.status === SIM_CHANGE_CONST.SUCCESS
          ) {
            this.manageLineService.close();
            this.generateSuccessfullySubmittedTag();

            const successModalRef = this.modalService.open(
              SuccessComponent,
              this.ngbModalOptions
            );
            successModalRef.componentInstance.tagEnabledByCaller = true;
            successModalRef.componentInstance.nameTag = this.nameTag;

            successModalRef.componentInstance.modalBodyContent = this.authoringContentData.confirmationMsgTxt.replace(
              "{{emailID}}",
              _.get(
                JSON.parse(
                  this._cacheSvc.getFromSessionStorage(
                    COMMON_CONSTANTS.EUI_TOKEN_DATA
                  )
                ),
                "logonId",
                ""
              )
            );
            successModalRef.componentInstance.isPortIn = true;
            successModalRef.componentInstance.multiLineFlow = true;
            successModalRef.componentInstance.header = this.authoringContentData.MultiLineSuccessModalTitle;
            // tslint:disable-next-line: max-line-length
            successModalRef.componentInstance.portInSuccessTransaction = this.authoringContentData.bulktransactionNumberTxt.replace(
              "{{transID}}",
              data.token
            );
            successModalRef.componentInstance.transactionID = data.token;
            successModalRef.componentInstance.selectedLines = this.selectedLines;
          } else {
            this.utilsSvc.errorHandling(null);
            this._loaderSvc.stop();
          }
        },
        (error) => {
          this.manageLineService.close();
          this.utilsSvc.errorHandling(error);
        }
      );
  }

  submitTransferNumberRequest() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.SUBMIT,
      assetType: ANALYTICS.BUTTON,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });

    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      container: '#am-container-custom',
    };
    this._loaderSvc.start();
    if (this.individually) {
      this.submitSingleTransferNumberRequest();
    } else {
      this.submitBulkTransferNumberRequest();
    }
  }

  updatedPortinBulkRequestHeader(portLines) {
    const multiLineBulkPortinHeaders = new MultiLineBulkPortinHeaders();
    for (let index = 0; index < portLines.length; index++) {
      const requestsBulkPortin = new RequestsBulkPortin();

      requestsBulkPortin.logonId = _.get(
        JSON.parse(
          this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)
        ),
        "logonId",
        ""
      );
      requestsBulkPortin.orgId = this._helperUtilSvc.getOrgID();
      requestsBulkPortin.email = _.get(
        JSON.parse(
          this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)
        ),
        "logonId",
        ""
      );
      requestsBulkPortin.billingAccountNumber = this._cacheSvc.getFromSessionStorage(
        COMMON_CONSTANTS.BAN_NUMBER_KEY
      ); // BAN
      let formateedDate =
        portLines[index][TRANSFER_NUMBER_CONSTANTS.PORT_DATE].month +
        "/" +
        portLines[index][TRANSFER_NUMBER_CONSTANTS.PORT_DATE].day +
        "/" +
        portLines[index][TRANSFER_NUMBER_CONSTANTS.PORT_DATE].year;
      requestsBulkPortin.portInDateTime = this.utilsSvc.getPortInDateTime(
        formateedDate,portLines[index][TRANSFER_NUMBER_CONSTANTS.PORT_TIME]
      );
      requestsBulkPortin.msisdn =
        portLines[index][TRANSFER_NUMBER_CONSTANTS.MSISDN]; // T-Mobile MSISDN     data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]
      requestsBulkPortin.newMsisdn =
        portLines[index][TRANSFER_NUMBER_CONSTANTS.TRAN_NUMBER]; // Number to Transfer
      requestsBulkPortin.reasonCode = TRANSFER_NUMBER_CONSTANTS.REASON_CODE_PR;
      requestsBulkPortin.ospAccountPassword =
        portLines[index][TRANSFER_NUMBER_CONSTANTS.ACCOUNT_PIN_PASS]; // Account Pin or Password
      requestsBulkPortin.ospAccount =
        portLines[index][TRANSFER_NUMBER_CONSTANTS.CARRIER_NUMBER]; // Carrier Account Number
      multiLineBulkPortinHeaders.requests[index] = requestsBulkPortin;
    }
    return multiLineBulkPortinHeaders;
  }
  isLengthValid(line: any) {
    if (
      !isNullOrUndefined(line.tranNumber) &&
      typeof line.tranNumber === "string"
    ) {
      const val = line.tranNumber.replace(/\D/g, "");
      if (val.length === VALUE.TEN) {
        return true;
      } else if (val.length < 10) {
        line.isNumberToTransferValid = false;
        return false;
      }
    }
  }
  enableSubmitButton() {
    for (let i = 0; i < this.selectedLines.length; i++) {
      if (
        (this.selectedLines[i].isAccordionValidated === true &&
          this.selectedLines[i].isValidNumberToTfr === true &&
          this.selectedLines[i].errorOrSuccessMessage === true &&
          this.selectedLines[i].isCarrierNumberValid === true) ||
        (this.selectedLines[i].isCarrierNumberAll === true &&
          this.selectedLines[i].isValidNumberToTfr === true &&
          this.selectedLines[i].errorOrSuccessMessage === true &&
          this.selectedLines[i].isCarrierNumberValid === true)
      ) {
        if (i === this.selectedLines.length - 1) {
          this.enableSubmitBtn = true;
        }
      } else {
        this.enableSubmitBtn = false;
        break;
      }
    }
  }

  isValidCarrierNumber(carrierNumber) {
    const numLength = carrierNumber.toString().length;
    return numLength >= VALUE.ONE && numLength <= VALUE.THIRTY;
  }

  validateAccountNumber(line: any, param?: boolean) {
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.carrierNumber)) {
      if (this.isValidCarrierNumber(line.carrierNumber)) {
        line.isCarrierNumberValid = true;

        if (
          line.isCarrierNumberValid === true &&
          line.isValidNumberToTfr === true &&
          line.errorOrSuccessMessage === true
        ) {
          line.isAccordionValidated = true;
          line.expendFlagValue = false;
          this.isLineValidated = true;
          const nextIndex = this.selectedLines.findIndex(
            (item) => item.msisdn === line.msisdn
          );
          if (this.selectedLines.length - 1 > nextIndex) {
            this.selectedLines[nextIndex + 1].expendFlagValue = true;
          }
          this.selectedLines[nextIndex].expendFlagValue = false;
          this.errorOrSuccessMessage = false;
          this.enableSubmitButton();
        } else {
          this.enableSubmitButton();
        }
      } else {
        line.isCarrierNumberValid = false;
        this.enableSubmitBtn = false;
      }
    } else {
      line.missingCarrierNumber = true;
      this.enableSubmitButton();
    }
  }


  // method for setting step for accordian
  setStep(i) {
    this.manageLineService.setStep(i);
  }
  nextStep(line) {
    const nextIndex = this.selectedLines.findIndex(
      (item) => item.msisdn === line.msisdn
    );
    this.selectedLines[nextIndex + 1].expendFlagValue = true;
  }

  toggleText(ref) {
    if (ref.type === "password") {
      ref.type = "text";
    } else {
      ref.type = "password";
    }
  }

  getNumberEligibiltyForMultiLine(line: any, accountNumber?: any) {
    if (!isNullOrUndefined(line.tranNumber)) {
      if (this.regex21.test(line.tranNumber)) {
        line.isValidNumberToTfr = true;
        this.isDisabled = false;
      } else {
        line.isValidNumberToTfr = false;
        this.isDisabled = true;
      }
    }
    if (!isNullOrUndefined(accountNumber)) {
      this.checkEligibilityForMultiLine(line, accountNumber);
    } else {
      this.checkEligibilityForMultiLine(line);
    }
  }
  checkEligibilityForMultiLine(line, accountNumber?: any) {
    if (!isNullOrUndefined(line.tranNumber) && line.tranNumber.length > 9) {
      this._loaderSvc.start();
      const objTransferNumber = new portInEligibilityRequest();
      objTransferNumber.billingAccountNumber = !isNullOrUndefined(
        this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY)
      )
        ? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY)
        : "";
      objTransferNumber.type = TRANSFER_NUMBER_CONSTANTS.ELIGIBILITY_REQ_TYPE;
      const msisdnReq = new portInMsisdnReq();
      msisdnReq.portInDateTime = this.calenderDateToUTC(line.portDate);
      msisdnReq.oldMsisdn = this.selectedLines[
        COMMON_CONSTANTS.DIGITS.ZERO
      ].msisdn;
      msisdnReq.portInNumber = line.tranNumber;
      if (!isNullOrUndefined(accountNumber)) {
        msisdnReq.ospAccountNumber = accountNumber;
      }
      objTransferNumber.msisdns[COMMON_CONSTANTS.DIGITS.ZERO] = msisdnReq;
      objTransferNumber.billingAccountNumber = !isNullOrUndefined(
        this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY)
      )
        ? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY)
        : "";
      this.manageLineService
        .transferNumberSingleLineEligibilty(objTransferNumber)
        .subscribe(
          (data) => {
            this.checkEligibilityForMultiLineResponse(line, data);
          },
          (error) => {
            line.errorOrSuccessMessage = false;
            this.enableSubmitButton();
            this._loaderSvc.stop();
          }
        );
    } else {
      line.errorOrSuccessMessage = false;
      this.enableSubmitButton();
    }
  }
  checkEligibilityForMultiLineResponse(line, data) {
    if (!isNullOrUndefined(data) && !isNullOrUndefined(data.msisdns) && !isNullOrUndefined(data.msisdns[COMMON_CONSTANTS.DIGITS.ZERO].status)
      && data.msisdns[COMMON_CONSTANTS.DIGITS.ZERO].status === MANAGE_LINE_CONST.SUCCESS
      && !isNullOrUndefined(data.msisdns[COMMON_CONSTANTS.DIGITS.ZERO].portInAvailableDate)) {
      line.errorOrSuccessMessage = true;

      if (!isNullOrUndefined(line.isCarrierNumberAll) && line.isCarrierNumberAll === true) {
        line.isAccordionValidated = true;
        line.expendFlagValue = false;
        const nextIndex = this.selectedLines.findIndex((item) => item.msisdn === line.msisdn);
        if (this.selectedLines.length - 1 > nextIndex) {
          this.selectedLines[nextIndex + 1].expendFlagValue = true
        }
        this.selectedLines[nextIndex].expendFlagValue = false;
      }
      this.mapEligibleTransferDate(data);
      this._loaderSvc.stop();
      this.enableSubmitButton();
    } else {
      line.errorOrSuccessMessage = false;
      this.enableSubmitButton();
      this._loaderSvc.stop();
    }
  }
  generateModalViewTag() {
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: this.nameTag,
      stage: ANALYTICS.STAGE_START,
      name: this.nameTag
    });
  }

  closeWithXBtn() {
    this.manageLineService.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CLOSE,
      assetType: ANALYTICS.LINK,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }

  generateMaxAttemptsTag() {
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }

  generateMaxAttemptsDoneTag() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.DONE,
      assetType: ANALYTICS.BUTTON,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }

  generateMaxAttemptsXTag() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CLOSE,
      assetType: ANALYTICS.LINK,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }

  generateSuccessfullySubmittedTag() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      assetType: ANALYTICS.BUTTON,
      ctaName: ANALYTICS.SUBMIT,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }

  closeWithCancelBtn() {
    this.manageLineService.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CANCEL,
      assetType: ANALYTICS.BUTTON,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }

  matPanelOpenCloseClickTag(openOrClosed) {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.LINE_NUMBER,
      assetType: openOrClosed,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }
  calendarClickTag() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.TRANSFER_DATE_SELECTOR,
      assetType: ANALYTICS.ICON,
      modalName: this.nameTag,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.nameTag
    });
  }
  checkInputChange(){
    this.eligiblilityCalled = false;
  }
}
